import { GenericSummaryCardDtoResponse } from "./generic-summary-card.dto-response";

export class SkuList {
  skus: string[];
  index: number;

  constructor(cards: GenericSummaryCardDtoResponse[]) {
    this.skus = [];
    this.populate(cards);
  }

  setIndex(sku: string) {
    this.index = this.skus.indexOf(sku);
  }

  populate(cards: GenericSummaryCardDtoResponse[]) {
    if (cards !== null && cards !== undefined) {
      for (var i = 0, l = cards.length; i < l; i++) {
        if (cards[i].rearProduct)
          this.skus.push(`${cards[i].frontProduct.longSKU}_${cards[i].rearProduct.longSKU}`);
        else
          this.skus.push(cards[i].frontProduct.longSKU);
      }
    }
  }

  get prev(): string {
    let sku = '';
    if (this.index > 0)
      sku = this.skus[this.index - 1];
    return sku;
  }

  get next(): string {
    let sku = '';
    if (this.index < this.skus.length - 1)
      sku = this.skus[this.index + 1];
    return sku;
  }

  get canMovePrev(): boolean {
    return this.prev !== '';
  }

  get canMoveNext(): boolean {
    return this.next !== '';
  }

  // djb:refactor 
  //movePrev(): void {
  //  if (this.canMovePrev) {
  //    this.setIndex(this.prev);
  //  }
  //}

  //moveNext(): void {
  //  if (this.canMoveNext) {
  //    this.setIndex(this.next);
  //  }
  //}

}
